import { Extension } from '@tiptap/core'

export interface IndentOptions {
  /**
   * The types where the indent attribute can be applied.
   * @default []
   * @example ['heading', 'paragraph']
   */
  types: string[],

  /**
   * The default indent.
   * @default '0'
   * @example '40'
   */
  defaultIndent: number | null,

  /**
   * Increment indent by.
   * @default '40'
   * @example '80'
  */
  indentIncrement: number,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      increaseIndent: () => ReturnType,
      decreaseIndent: () => ReturnType,
    }
  }
}

export const Indent = Extension.create<IndentOptions>({
  name: 'indent',

  addOptions() {
    return {
      types: [],
      defaultIndent: 0,
      indentIncrement: 40,
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          marginLeft: {
            default: this.options.defaultIndent,
            parseHTML: element => {
              const indent = element.style.marginLeft

              return parseInt(indent, 10) || 0
            },
            renderHTML: attributes => {
              if (!attributes.marginLeft) {
                return {}
              }

              return { style: `margin-left: ${attributes.marginLeft}px` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      increaseIndent: () => ({ editor, commands }) => {
        return this.options.types
          .map(type => { 
            const attributes = editor.getAttributes(type);

            commands.updateAttributes(type, { marginLeft: attributes.marginLeft + this.options.indentIncrement })
          })
          .every(response => response)
      },

      decreaseIndent: () => ({ editor, commands }) => {
        return this.options.types
          .map(type => { 
            const attributes = editor.getAttributes(type);
            if (attributes.marginLeft - this.options.indentIncrement < 0) {
              commands.updateAttributes(type, { marginLeft: 0 })
            } else {
              commands.updateAttributes(type, { marginLeft: attributes.marginLeft - this.options.indentIncrement })
            }
          })
          .every(response => response)
      },
    }
  },

  // addKeyboardShortcuts() {
  //   return {
  //     'Tab': () => this.editor.commands.increaseIndent(),
  //     'Shift-Tab': () => this.editor.commands.decreaseIndent(),
  //   }
  // },
})